<div class="standby-detail">
  <button class="standby-detail__close" type="button" (click)="close()" aria-label="Fechar">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  </button>

  <header class="standby-detail__header">
    <h2 class="standby-detail__title" id="standby-detail-title">Lista de Tripulantes Stand by</h2>
    <p class="standby-detail__subtitle" id="standby-detail-subtitle">Sistema PasseLivre</p>
  </header>

  <div class="standby-detail__body">
    <div class="standby-detail__group">
      <div class="standby-detail__group-icon">
        <img src="assets/images/latam-logo.png" alt="LATAM" class="standby-detail__latam-logo" />
      </div>
      <strong class="standby-detail__count">{{ totalLatam }}</strong>
      <span class="standby-detail__label">Tripulantes LATAM</span>
    </div>

    <hr class="standby-detail__divider" aria-hidden="true" />

    <div class="standby-detail__group">
      <div class="standby-detail__group-icon standby-detail__group-icon--external">
        <svg class="standby-detail__external-icon" width="58" height="58" viewBox="0 0 64 64" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="29" cy="33" r="20"/>
          <path d="M9 33h40M29 13c6 6 9 13 9 20s-3 14-9 20M29 13c-6 6-9 13-9 20s3 14 9 20"/>
          <path class="standby-detail__external-plane" fill="currentColor" stroke="none"
            d="M57.7 8.2c-1.1-1.1-3.2-.5-5.5 1.8l-5.4 5.4-8.6-2.1-2.2 2.2 7 4-4.2 4.2-3.7-.5-1.7 1.7 4.4 2.4 2.4 4.4 1.7-1.7-.5-3.7 4.2-4.2 4 7 2.2-2.2-2.1-8.6 5.4-5.4c2.3-2.3 2.9-4.4 1.8-5.5Z"/>
        </svg>
      </div>
      <strong class="standby-detail__count">{{ totalExternal }}</strong>
      <span class="standby-detail__label">Tripulantes de outras companhias aéreas</span>
    </div>
  </div>

  <footer class="standby-detail__footer">
    <button type="button" class="standby-detail__btn-close" (click)="close()">Fechar</button>
  </footer>
</div>
